import React from "react";
import PageHero from "../components/PageHero";

export default function Terms() {
  return (
    <div>
      <PageHero title="Terms of Service" breadcrumb="Terms of Service" subtitle="OnlineCricketID.guru ki services ko use karne se pehle yeh terms padhna zaruri hai. Last updated: 24 June 2026." />
      <section className="section-pad">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="card-dark p-6 md:p-9 space-y-6 text-slate-300 leading-relaxed text-[15px]">
            <section>
              <h2 className="text-xl font-bold text-white">1. Eligibility</h2>
              <p className="mt-2">OnlineCricketID.guru ki services sirf 18 saal ya usse adhik umar wale users ke liye hai. Service use karke aap confirm karte hain ki aap apne local jurisdiction ke laws ke according eligible hain.</p>
            </section>
            <section>
              <h2 className="text-xl font-bold text-white">2. Service Nature</h2>
              <p className="mt-2">OnlineCricketID.guru third-party sports exchanges aur gaming platforms ke saath referral & ID provisioning service provide karta hai. Hum kisi bhi exchange ko directly operate nahi karte. Aapki bet, deposit, withdrawal direct exchange ke saath hoti hai.</p>
            </section>
            <section>
              <h2 className="text-xl font-bold text-white">3. Account Use</h2>
              <p className="mt-2">User apni login credentials ki security ke khud zimmedaar hain. Account share karna, transfer karna ya unauthorized access dena strictly prohibited hai aur aisa karne par account permanent suspend ho sakta hai.</p>
            </section>
            <section>
              <h2 className="text-xl font-bold text-white">4. Payments & Withdrawals</h2>
              <p className="mt-2">All transactions exchange platforms ke through hote hain. Deposit aur withdrawal timings aam taur par 3-15 minute hain, lekin bank server, KYC verification ya unforeseen reasons ke karan delay ho sakta hai.</p>
            </section>
            <section>
              <h2 className="text-xl font-bold text-white">5. Prohibited Activities</h2>
              <p className="mt-2">Bots, multi-accounting, match-fixing related activities ya kisi bhi prakaar ke fraud ko strictly prohibited maana jaayega. Aisi activities pakdne par account suspend aur funds frozen kiye ja sakte hain.</p>
            </section>
            <section>
              <h2 className="text-xl font-bold text-white">6. Limitation of Liability</h2>
              <p className="mt-2">OnlineCricketID.guru aur uske partners kisi bhi financial loss, downtime, ya force majeure event ke liye liable nahi hain. Users apni risk par services use karte hain.</p>
            </section>
            <section>
              <h2 className="text-xl font-bold text-white">7. Geographic Restrictions</h2>
              <p className="mt-2">Access to this site is restricted in certain geographies including but not limited to USA, UK, France, Germany, China, Australia, Singapore aur kuch dusre territories. Users apne local laws ke responsible hain.</p>
            </section>
            <section>
              <h2 className="text-xl font-bold text-white">8. Modifications</h2>
              <p className="mt-2">OnlineCricketID reserve karta hai right to modify ye terms anytime. Major changes notify kiye jaayenge website par. Continued use modified terms ke acceptance ke baraabar hai.</p>
            </section>
            <section>
              <h2 className="text-xl font-bold text-white">9. Contact</h2>
              <p className="mt-2">Kisi bhi sawaal ke liye support@onlinecricketid.guru par email karein ya WhatsApp par message bhejein.</p>
            </section>
          </div>
        </div>
      </section>
    </div>
  );
}
